<template>
  <v-container>
    <v-dialog v-model="showDialog" max-width="480px" persistent>
      <v-card>
        <v-card-title class="headline">Akses Pengisian Aktivitas</v-card-title>
        <v-card-text>
          {{ cardText }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="redirectToPage()">Mengerti</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AktivitasService from '@/services/AktivitasService'
import store from '@/store'

export default {
  data() {
    return {
      showDialog: false,
      cardText: '',
      validationData: []
    }
  },
  created() {
    const { year } = store.state.user.current
    if (year >= 2024) {
      this.validateAktivitas()
    }
  },
  methods: {
    async validateAktivitas() {
      try {
        await AktivitasService.isAllowedIsiAktivitas()
      } catch (err) {
        const data = err.response?.data || {}
        this.validationData = data.data?.details || []
        this.cardText = data.message || 'Server sedang sibuk, silahkan coba beberapa saat lagi'
        this.showDialog = true
      }
    },
    redirectToPage() {
      this.$router.push('/skp/tahunan')
    }
  }
}
</script>
